import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SetItemProductionMappingsMutationVariables = Types.Exact<{
  input: Types.SetItemProductionMappingsInput;
}>;


export type SetItemProductionMappingsMutation = { __typename?: 'Mutation', setItemProductionMappings: { __typename?: 'ItemProductionMappingPayload', mapping?: { __typename?: 'ItemProductionMappingStateData', salesItemId: string, updatedAt: Types.TDateISO, updatedBy: string, lines: Array<{ __typename?: 'ItemProductionMappingLineStateData', productionItemId: string, mixPct: number, startIsoYear?: number | null, startIsoWeek?: number | null, endIsoYear?: number | null, endIsoWeek?: number | null, regions: Array<string> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const SetItemProductionMappingsDocument = new TypedDocumentString(`
    mutation SetItemProductionMappings($input: SetItemProductionMappingsInput!) {
  setItemProductionMappings(input: $input) {
    mapping {
      ...ItemProductionMappingState
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemProductionMappingState on ItemProductionMappingStateData {
  salesItemId
  updatedAt
  updatedBy
  lines {
    productionItemId
    mixPct
    startIsoYear
    startIsoWeek
    endIsoYear
    endIsoWeek
    regions
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetItemProductionMappings: build.mutation<SetItemProductionMappingsMutation, SetItemProductionMappingsMutationVariables>({
      query: (variables) => ({ document: SetItemProductionMappingsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetItemProductionMappingsMutation } = injectedRtkApi;
